import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import type BetaToggleService from 'scaleflow/services/beta-toggle';
import type RfiService from 'scaleflow/services/rfi';
import ArrowDownTray from 'scaleflow/components/tailwind-icons/arrow-down-tray';

export interface RfiDownloadAllSignature {
  Element: HTMLButtonElement;
  Args: object;
}

/** Platform admins only: bundles every uploaded RFI file into one zip. */
export default class RfiDownloadAll extends Component<RfiDownloadAllSignature> {
  @service declare rfi: RfiService;
  @service declare betaToggle: BetaToggleService;

  get isDisabled(): boolean {
    return this.rfi.totalFiles === 0 || this.rfi.isDownloadingAll;
  }

  @action
  download() {
    void this.rfi.downloadAll();
  }

  <template>
    {{#if this.betaToggle.isPlatformAdmin}}
      <button
        type="button"
        class="flex shrink-0 items-center gap-x-2 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
        disabled={{this.isDisabled}}
        {{on "click" this.download}}
        ...attributes
      >
        <ArrowDownTray class="h-4 w-4" />
        {{#if this.rfi.isDownloadingAll}}
          {{t "rfi.downloading-all"}}
        {{else}}
          {{t "rfi.download-all"}}
        {{/if}}
      </button>
    {{/if}}
  </template>
}
